module.exports = __webpack_public_path__ + "img/paragraph-line-3.f02ebbf9.svg";